module.exports = __webpack_public_path__ + "static/media/gloves.a74c3469.png";